import {Reducer} from "redux";
import {ErrorState} from "../models/axios";

const initialState = {
  error: null,
};

const reducer: Reducer<ErrorState> = (state = initialState, action) => {
  switch (action.type) {
    default:
      if ((action.type.indexOf("_ERROR") != -1) && (action.payload && action.payload.status != 401)) {
        return {
          error : action.payload
        }
      }
      return initialState;
  }
};


export {reducer as errorReducer};


